import { makeAutoObservable } from "mobx";

interface IMenuState {
    open: boolean;
}

export class MenuState implements IMenuState {
    open: boolean;

    constructor(open?: boolean) {
        makeAutoObservable(this);

        this.open = open || false;
    }

    setOpen(open: boolean) {
        this.open = open;
    }
}